import {
  QueryClientImpl,
  QueryGranteeGrantsResponse,
  QueryGranterGrantsResponse,
  QueryGrantsResponse
} from "@shareledgerjs/types/cosmos/authz/v1beta1/query";

import {BaseClient} from "../../baseclient";
import {createPagination, createProtobufRpcClient, ProtobufRpcClient} from "../../query";

export interface AuthzQueryExtensionMethods {
  grants(granter: string, grantee: string, msgTypeUrl: string, paginationKey?: Uint8Array, height?: number): Promise<QueryGrantsResponse>;
  granteeGrants(grantee: string, paginationKey?: Uint8Array, height?: number): Promise<QueryGranteeGrantsResponse>;
  granterGrants(granter: string, paginationKey?: Uint8Array, height?: number): Promise<QueryGranterGrantsResponse>;
}

export interface AuthzQueryExtension {
  readonly authz: AuthzQueryExtensionMethods;
}

export function AuthzQueryExtension<T extends {new (...args: any[]): BaseClient & AuthzQueryExtension}>(constructor: T): T {
  let queryService: QueryClientImpl;
  let rpcClient: ProtobufRpcClient;
  return class extends constructor {
    constructor(...args: any[]) {
      super(...args);
      // Use this service to get easy typed access to query methods
      // This cannot be used for proof verification
      rpcClient = createProtobufRpcClient(this.forceGetQueryClient());
      queryService = new QueryClientImpl(rpcClient);
    }
    override get authz() {
      return {
        ...super["authz"],
        grants: async (granter: string, grantee: string, msgTypeUrl: string, paginationKey?: Uint8Array, height?: number) => {
          rpcClient.withHeight(height);
          return queryService.Grants({grantee, granter, msgTypeUrl, pagination: createPagination(paginationKey)});
        },
        granteeGrants: (grantee: string, paginationKey?: Uint8Array, height?: number) => {
          rpcClient.withHeight(height);
          return queryService.GranteeGrants({grantee, pagination: createPagination(paginationKey)});
        },
        granterGrants: (granter: string, paginationKey?: Uint8Array, height?: number) => {
          rpcClient.withHeight(height);
          return queryService.GranterGrants({granter, pagination: createPagination(paginationKey)});
        }
      };
    }
  };
}
